import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "../seo/Seo";
import { SITE } from "../seo/states";
import { BLOG_CATEGORIES, BLOG_POSTS, getCategory } from "../seo/blog";
import { PageShell } from "../components/PageShell";

export default function BlogIndex() {
  const url = `${SITE}/blog`;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "Alexa Financial Multiservices Blog",
    url,
    description: "Expert guides on business formation, funding, business credit and website design.",
  };
  return (
    <PageShell
      eyebrow="Resources"
      title="The Alexa Financial Blog"
      subtitle="Expert guides on business formation, funding, business credit and professional website design — practical insights to help you build and grow."
      breadcrumb={[{ label: "Home", to: "/" }, { label: "Blog" }]}
    >
      <Seo title="Business Formation, Funding & Web Design Blog | Alexa Financial" description="Expert guides on LLC formation, EIN, business funding, business credit and website design to help entrepreneurs build and grow." keywords="business formation blog, funding tips, business credit guide, website design blog" canonical={url} jsonLd={jsonLd} />

      {/* Categories */}
      <section className="py-14 bg-[#050505]">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10">
          <div className="flex flex-wrap gap-3">
            {BLOG_CATEGORIES.map((c) => (
              <Link key={c.slug} to={`/blog/category/${c.slug}`} data-testid={`blog-cat-${c.slug}`} className="glass rounded-full px-5 py-2.5 text-sm text-[#d4d4d4] hover:text-white hover:border-[#d4af37]/40 transition-colors">
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Posts */}
      <section className="pb-24 bg-[#050505]">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOG_POSTS.map((p, i) => (
            <motion.article
              key={p.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className="group glass rounded-2xl p-8 flex flex-col hover:border-[#d4af37]/40 transition-colors duration-500"
            >
              <div className="text-[11px] tracking-[0.25em] uppercase text-[#d4af37]">{getCategory(p.category)?.name}</div>
              <h2 className="mt-3 font-display text-2xl text-white leading-snug">
                <Link to={`/blog/${p.slug}`} data-testid={`blog-post-${p.slug}`} className="hover:text-[#e9d08a] transition-colors">{p.title}</Link>
              </h2>
              <p className="mt-3 text-[#a3a3a3] leading-relaxed flex-1">{p.excerpt}</p>
              <div className="mt-6 flex items-center justify-between text-sm text-[#888]">
                <span>{p.readingTime} read</span>
                <Link to={`/blog/${p.slug}`} className="inline-flex items-center gap-1 text-[#d4af37] group-hover:gap-2 transition-all">Read <ArrowUpRight size={14} /></Link>
              </div>
            </motion.article>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
